"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Perpetual = exports.HistoryPerpetualStatus = exports.PerpetualStatus = void 0;
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const types_1 = require("../types");
const int256_1 = require("./int256");
const tokenAmount_1 = require("./tokenAmount");
var PerpetualStatus;
(function (PerpetualStatus) {
    PerpetualStatus["open"] = "perpetuals.status.open";
    PerpetualStatus["close"] = "perpetuals.status.closed";
    PerpetualStatus["liquidate"] = "perpetuals.status.liquidated";
    PerpetualStatus["forceClose"] = "perpetuals.status.forceClosed";
})(PerpetualStatus = exports.PerpetualStatus || (exports.PerpetualStatus = {}));
var HistoryPerpetualStatus;
(function (HistoryPerpetualStatus) {
    HistoryPerpetualStatus["close"] = "perpetuals.status.closed";
    HistoryPerpetualStatus["liquidate"] = "perpetuals.status.liquidated";
    HistoryPerpetualStatus["forceClose"] = "perpetuals.status.forceClosed";
})(HistoryPerpetualStatus = exports.HistoryPerpetualStatus || (exports.HistoryPerpetualStatus = {}));
class Perpetual {
    constructor(chainId, perpetualID, margin, committedAmount, stable, collateral, entryRate, perpetualManagerAddress, creationDate, status, lastUpdated, openingBlockNumber, lastUpdateBlockNumber, liquidationPrice) {
        (0, tiny_invariant_1.default)(Number.isSafeInteger(chainId), 'CHAIN_ID');
        (0, tiny_invariant_1.default)(Number.isSafeInteger(perpetualID), 'PERPETUAL_ID');
        (0, tiny_invariant_1.default)(!stable.eq(collateral), 'STABLE/COLLATERAL');
        this.perpetualManagerAddress = (0, types_1.validateAndParseAddress)(perpetualManagerAddress);
        this.chainId = chainId;
        this.perpetualId = perpetualID;
        this.id = `${perpetualManagerAddress}_${perpetualID}`;
        this.margin = new tokenAmount_1.TokenAmount(collateral, margin);
        this.committedAmount = new tokenAmount_1.TokenAmount(collateral, committedAmount);
        this.liquidationPrice = int256_1.Int256.from(liquidationPrice);
        this.stable = stable;
        this.collateral = collateral;
        this.entryRate = int256_1.Int256.from(entryRate);
        this.coveredAmount = this.committedAmount.mul(this.entryRate);
        this.distToTargetHedge = int256_1.Int256.from(0);
        this.creationDate = creationDate;
        this.lastUpdated = lastUpdated;
        this.openingBlockNumber = parseInt(openingBlockNumber, 10);
        this.lastUpdateBlockNumber = parseInt(lastUpdateBlockNumber, 10);
        this.status = PerpetualStatus[status];
    }
    static fromTgPerp(perpetual, stable, collateral, chainId) {
        return new Perpetual(chainId, parseInt(perpetual.perpetualID, 10), perpetual.margin, perpetual.committedAmount, stable, collateral, perpetual.entryRate, perpetual.perpetualManager, parseInt(perpetual.openingTimestamp, 10) * 1000, perpetual.status, parseInt(perpetual.lastUpdateTimestamp, 10) * 1000, perpetual.openingBlockNumber, perpetual.lastUpdateBlockNumber, perpetual.liquidationPrice);
    }
    eq(other) {
        if (this === other) {
            return true;
        }
        const equivalent = this.chainId === other.chainId && this.id === other.id && this.perpetualManagerAddress === other.perpetualManagerAddress;
        if (equivalent) {
            (0, tiny_invariant_1.default)(this.stable.decimals === other.stable.decimals && this.collateral.decimals === other.collateral.decimals, 'DECIMALS');
            if (this.stable.symbol && other.stable.symbol) {
                (0, tiny_invariant_1.default)(this.stable.symbol === other.stable.symbol, 'STABLE SYMBOL');
            }
            if (this.collateral.symbol && other.collateral.symbol) {
                (0, tiny_invariant_1.default)(this.collateral.symbol === other.collateral.symbol, 'COLLATERAL SYMBOL');
            }
            if (this.stable.name && other.stable.name) {
                (0, tiny_invariant_1.default)(this.stable.name === other.stable.name, 'STABLE NAME');
            }
            if (this.collateral.name && other.collateral.name) {
                (0, tiny_invariant_1.default)(this.collateral.name === other.collateral.name, 'COLLATERAL NAME');
            }
            (0, tiny_invariant_1.default)(this.margin === other.margin, 'BROUGHT');
            (0, tiny_invariant_1.default)(this.committedAmount === other.committedAmount, 'COMMITTED');
            (0, tiny_invariant_1.default)(this.entryRate === other.entryRate, 'RATE');
        }
        return equivalent;
    }
}
exports.Perpetual = Perpetual;
//# sourceMappingURL=perpetual.js.map